export default {
  title: {
    id: 'reassurance_cooling_off_days',
    defaultMessage: '{days}-day money back guarantee',
  },
}
